import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';
import { Transition }               from '@uirouter/core';

import { QuickbooksConnectionComponent } from './quickbooks.connection.component';
import { QuickbooksCountryComponent }    from './quickbooks.country.component';
import { QuickbooksSignupComponent }     from './quickbooks.signup.component';
import { UserService }                   from '../users/user.service';

export const QuickbooksStates : Array<NgHybridStateDeclaration> = [
  {
    component: QuickbooksConnectionComponent,
    name     : 'app.quickbooks-connection',
    url      : '/quickbooks-connection?disconnect&qbo_login&qbo_sso_token'
  },
  {
    component: QuickbooksCountryComponent,
    name     : 'app.quickbooks-country',
    resolve  : [
      {
        deps     : [ UserService ],
        resolveFn: ( userService : UserService ) => userService.getCountries(),
        token    : 'countries'
      }
    ],
    url: '/quickbooks-country?disconnect&qbo_login&qbo_sso_token'
  },
  {
    component: QuickbooksSignupComponent,
    name     : 'app.quickbooks-signup',
    resolve  : [
      {
        deps     : [ Transition ],
        resolveFn: ( transitionService : Transition ) => transitionService.params().country,
        token    : 'country'
      },
      {
        deps     : [ UserService ],
        resolveFn: ( userService : UserService ) => userService.getCountries(),
        token    : 'countries'
      }
    ],
    url: '/quickbooks-signup/:country?disconnect&qbo_login&qbo_sso_token'
  }
];
